export enum DeviceConnectionStatus
{
    Unset = "Unset",
    Offline = "Offline",
    Connected = "Connected",
    ConnectError = "ConnectError",
    Disconnected = "Disconnected"
}
